var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFi427735(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_427735",
    clipPath: "url(#clip0_7698_11360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.98959 9.93972C8.15209 9.39806 8.47709 8.91056 8.91043 8.53138C9.72293 7.85429 10.2375 6.82513 10.2375 5.68763C10.2375 3.57513 8.47711 1.84179 6.31043 1.95013C4.38749 2.03138 2.81665 3.65638 2.76249 5.57929C2.7354 6.77097 3.24999 7.82722 4.08959 8.53138C4.54999 8.91054 4.87499 9.39804 5.03749 9.93972H7.98959Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.1479 9.99386H6.39165L5.30831 5.95846C5.3354 5.95846 5.36247 5.95846 5.38956 5.95846C5.52497 5.95846 5.6604 5.9043 5.76872 5.79596C5.82288 5.7418 5.87706 5.71471 5.95831 5.71471C6.03956 5.71471 6.09372 5.7418 6.1479 5.79596C6.33749 6.01261 6.66249 6.01261 6.85206 5.79596C6.90622 5.7418 6.9604 5.71471 7.04165 5.71471C7.09581 5.71471 7.17706 5.7418 7.23124 5.79596C7.33958 5.9043 7.4479 5.95846 7.6104 5.95846C7.63749 5.95846 7.66456 5.95846 7.69165 5.95846L6.6354 9.99386H6.87915L7.98956 5.76886C7.98956 5.71471 7.98956 5.66052 7.9354 5.63346C7.88124 5.60636 7.82706 5.63346 7.79999 5.66055C7.74583 5.71471 7.69165 5.7418 7.63749 5.7418C7.55624 5.7418 7.50208 5.71471 7.42083 5.66055C7.31249 5.55221 7.20418 5.49805 7.06874 5.49805C6.93331 5.49805 6.82499 5.55221 6.71665 5.66055C6.60831 5.76889 6.44581 5.76889 6.33749 5.66055C6.25624 5.55221 6.12083 5.49805 5.9854 5.49805C5.84999 5.49805 5.71456 5.55221 5.63331 5.66055C5.57915 5.71471 5.4979 5.7418 5.41665 5.7418C5.36249 5.7418 5.28124 5.71471 5.25415 5.66055C5.22706 5.63346 5.1729 5.60639 5.11874 5.63346C5.06458 5.66055 5.03749 5.71471 5.06458 5.76886L6.1479 9.99386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.6604 12.4316C5.79583 12.7566 6.12083 13.0004 6.49999 13.0004C6.87915 13.0004 7.20415 12.7566 7.33958 12.4316H5.6604Z",
    fill: "#344A5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.50207 12.458H5.52498C5.25413 12.458 5.03748 12.2413 5.03748 11.9705V9.91211H7.98957V11.9705C7.98957 12.2413 7.77288 12.458 7.50207 12.458Z",
    fill: "#344A5E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.96247 10.9415H5.03747C4.87497 10.9415 4.73956 10.8061 4.73956 10.6436C4.73956 10.4811 4.87497 10.3457 5.03747 10.3457H7.96247C8.12497 10.3457 8.26038 10.4811 8.26038 10.6436C8.26038 10.8061 8.12497 10.9415 7.96247 10.9415Z",
    fill: "#415A6B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.96247 11.8888H5.03747C4.87497 11.8888 4.73956 11.7534 4.73956 11.5909C4.73956 11.4284 4.87497 11.293 5.03747 11.293H7.96247C8.12497 11.293 8.26038 11.4284 8.26038 11.5909C8.26038 11.7534 8.12497 11.8888 7.96247 11.8888Z",
    fill: "#415A6B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.49997 0C6.36456 0 6.22913 0.108342 6.22913 0.270842V1.19168C6.22913 1.32709 6.33747 1.46253 6.49997 1.46253C6.66247 1.46253 6.77081 1.35418 6.77081 1.19168V0.270842C6.77081 0.108342 6.63538 0 6.49997 0Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.87081 1.65157C2.76246 1.54323 2.59996 1.54323 2.49165 1.65157C2.38333 1.75991 2.38331 1.92241 2.49165 2.03073L3.14165 2.68073C3.24999 2.78907 3.41249 2.78907 3.52081 2.68073C3.62912 2.57239 3.62915 2.40989 3.52081 2.30157L2.87081 1.65157Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.03122 5.38867H1.11038C0.974972 5.38867 0.839539 5.49701 0.839539 5.65951C0.839539 5.79492 0.94788 5.93036 1.11038 5.93036H2.03122C2.16663 5.93036 2.30206 5.82201 2.30206 5.65951C2.30206 5.52408 2.16663 5.38867 2.03122 5.38867Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M3.14166 8.63984L2.49166 9.28984C2.38331 9.39818 2.38331 9.56068 2.49166 9.669C2.6 9.77731 2.7625 9.77734 2.87081 9.669L3.52081 9.019C3.62916 8.91066 3.62916 8.74816 3.52081 8.63984C3.41247 8.53152 3.25 8.5315 3.14166 8.63984Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.85833 8.63985C9.74999 8.53151 9.58749 8.53151 9.47914 8.63985C9.3708 8.74819 9.3708 8.91069 9.47914 9.01901L10.1291 9.66901C10.2375 9.77735 10.4 9.77735 10.5083 9.66901C10.6166 9.56067 10.6166 9.39817 10.5083 9.28985L9.85833 8.63985Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M11.8896 5.38867H10.9687C10.8333 5.38867 10.6979 5.49701 10.6979 5.65951C10.6979 5.79492 10.8062 5.93036 10.9687 5.93036H11.8896C12.025 5.93036 12.1604 5.82201 12.1604 5.65951C12.1604 5.52408 12.0521 5.38867 11.8896 5.38867Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M10.1291 1.65156L9.47914 2.30156C9.3708 2.4099 9.3708 2.5724 9.47914 2.68072C9.58749 2.78906 9.74999 2.78906 9.8583 2.68072L10.5083 2.03072C10.6166 1.92238 10.6166 1.75988 10.5083 1.65156C10.4 1.54324 10.2375 1.54322 10.1291 1.65156Z",
    fill: "#FFD15C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7698_11360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi427735);
export default __webpack_public_path__ + "static/media/fi_427735.ae66eb8c3fc5e3e80a4cb28116055e4f.svg";
export { ForwardRef as ReactComponent };